import styled from 'styled-components';
import { DEVICES, pickThemeFontStyles } from '@/theme';

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 1.5rem;
  max-width: 32rem;

  @media screen and ${DEVICES.LAPTOP_S} {
    ${pickThemeFontStyles('14', '16')};
    margin-bottom: 1.5rem;
  }
`;

export const StyledItem = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: flex-start;
  gap: 0.5rem;
`;

export const StyledLabel = styled.div`
  ${pickThemeFontStyles('14', '16')};
`;

export const StyledValue = styled.div`
  ${pickThemeFontStyles('14', '22')};
  text-align: left;
`;
